var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PayeeApi } from './shared/sdk/services';
import { GlobalEventsManager } from './events-manager.component';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { ConfirmComponent } from './shared/app/components/confirm.component';
import { ImageModalComponent } from './shared/app/components/image-modal.component';
import { DialogService } from "ng2-bootstrap-modal";
import { LoopBackConfig } from './shared/sdk/index';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from '../environments/environment';
var AppComponent = /** @class */ (function () {
    function AppComponent(idle, keepalive, userApi, eventsManager, dialogService, router, document) {
        var _this = this;
        this.idle = idle;
        this.keepalive = keepalive;
        this.userApi = userApi;
        this.eventsManager = eventsManager;
        this.dialogService = dialogService;
        this.router = router;
        this.document = document;
        this.idleState = 'Not started.';
        this.timedOut = false;
        this.lastPing = null;
        this.toPopUp = false;
        this.hidden = true;
        this.eventsManager.showPageEmitter.subscribe(function (res) {
            if (res == false) {
                _this.hidden = false;
            }
            else {
                _this.hidden = true;
            }
        });
        this.router.events.subscribe(function (val) {
            if (val instanceof NavigationStart && val.url == '/form') {
                _this.hidden = false;
            }
        });
        this.eventsManager.popUpMsgEmitter.subscribe(function (_a) {
            var msg = _a[0], timeout = _a[1];
            console.log("popUpMsgEmitter msg");
            console.log(msg);
            console.log("popUpMsgEmitter timeout: " + timeout);
            _this.popUpMsg = msg;
            _this.dialogService.addDialog(ConfirmComponent, {
                title: 'Attention',
                message: msg
            }, {
                closeByClickingOutside: true,
                autoCloseTimeout: timeout
            })
                .subscribe(function (isConfirmed) {
                console.log("addDialog: isConfirmed ");
                console.log(isConfirmed);
                //We get dialog result
                if (isConfirmed) {
                    // idle.interrupt();
                }
                else {
                    // this.eventsManager.logout();
                    _this.dialogService.removeAll();
                }
            });
        });
        this.eventsManager.popUpImageEmitter.subscribe(function (_a) {
            var img = _a[0], timeout = _a[1];
            console.log("popUpImageEmitter img");
            console.log(img);
            console.log("popUpImageEmitter timeout: " + timeout);
            _this.popUpMsg = img;
            _this.dialogService.addDialog(ImageModalComponent, {
                title: 'Attention',
                message: img
            }, {
                closeByClickingOutside: true,
                autoCloseTimeout: timeout
            })
                .subscribe(function (isConfirmed) {
                console.log("addDialog: isConfirmed ");
                console.log(isConfirmed);
                //We get dialog result
                if (isConfirmed) {
                    // idle.interrupt();
                }
                else {
                    // this.eventsManager.logout();
                    _this.dialogService.removeAll();
                }
            });
        });
        this.eventsManager.showPopUpEmitter.subscribe(function (popUp) {
            console.log("showPopUpEmitter popUp");
            console.log(popUp);
            // if (popUp !== null) {
            //   this.toPopUp = popUp;
            // } else {
            //   this.toPopUp = false;
            // }
        });
        // sets an idle timeout of 870 seconds
        idle.setIdle(870);
        // idle.setIdle(5);
        // sets a timeout period of 30 seconds. after 900 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(30);
        // idle.setTimeout(3);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onIdleEnd.subscribe(function () {
            _this.idleState = 'No longer idle.';
            if (_this.disposable) {
                _this.disposable.unsubscribe();
            }
            console.log(_this.idleState);
        });
        idle.onTimeout.subscribe(function () {
            _this.idleState = 'Timed out!';
            console.log(_this.idleState);
            _this.timedOut = true;
            _this.eventsManager.logout(true);
            _this.reset();
        });
        idle.onIdleStart.subscribe(function () { return __awaiter(_this, void 0, void 0, function () {
            var date;
            var _this = this;
            return __generator(this, function (_a) {
                this.idleState = 'You\'ve gone idle!';
                console.log(this.idleState);
                if (this.userApi.isAuthenticated()) {
                    date = new Date();
                    this.disposable = this.dialogService.addDialog(ConfirmComponent, {
                        title: 'Attention',
                        message: "Warning: Your session will expire in 30 seconds starting from " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "."
                    }, {
                        autoCloseTimeout: 3000,
                        closeByClickingOutside: true
                    })
                        .subscribe(function (isConfirmed) {
                        //We get dialog result
                        if (isConfirmed) {
                            idle.interrupt();
                        }
                        else {
                            _this.eventsManager.logout();
                            _this.reset();
                        }
                    });
                }
                return [2 /*return*/];
            });
        }); });
        idle.onTimeoutWarning.subscribe(function (countdown) { return _this.idleState = 'You will time out in ' + countdown + ' seconds!'; });
        keepalive.start();
        // Set ping interval to how often you want the accessToken to be 'refreshed'
        keepalive.interval(10);
        // replace countAccessTokens() with what you need to call to 'refresh' the accessToken life
        keepalive.onPing.subscribe(function () {
            if (_this.userApi.isAuthenticated()) {
                // console.log("ping");
                _this.userApi.getCurrent().subscribe(function (user) { return console.log("ping-" + user.first_name); }, function (err) {
                    console.log(err);
                    _this.eventsManager.logout(true);
                    _this.eventsManager.showPopUp("Your session has expired. Please login.");
                    _this.eventsManager.loaded(true);
                });
            }
        });
        this.reset();
    }
    AppComponent.prototype.ngOnInit = function () {
        // console.log(this.document.location.hostname);
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            //always scroll top when navigate change
            // window.scrollTo(0, 0)
        });
        if (!environment.production) {
            //production code
            LoopBackConfig.setBaseURL('https://m2upay.maybank2u.com.my');
            if (this.document.location.hostname == "172.31.99.77") {
                LoopBackConfig.setBaseURL('https://172.31.99.77:8443');
            }
            //local code
            //LoopBackConfig.setBaseURL('http://localhost:3001');
        }
        else if (environment.production) {
            LoopBackConfig.setBaseURL('https://m2upay.maybank2u.com.my');
            if (this.document.location.hostname == "202.162.18.55") {
                LoopBackConfig.setBaseURL('https://202.162.18.55');
            }
        }
    };
    AppComponent.prototype.reset = function () {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    };
    return AppComponent;
}());
export { AppComponent };
